import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {createAction as createTypedAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'INQUIRY_MODALS';

export const {action: selectTab} = createAction(`${domain}/SELECT_TAB`, tab => ({tab}));

export const {action: showStartIn} = createAction(`${domain}/SHOW_START_IN`, show => ({show}));

export const {
    action: startIn,
    success: startInSuccess,
    failed: startInFailed,
} = createAction(`${domain}/START_IN`, (inquiryId, data, translationData) => ({inquiryId, data, translationData}));

export const {action: showInquiryModal} = createTypedAction(
    `${domain}/SHOW_INQUIRY_MODAL`,
    (showModal, inquiryId, institutionId) => ({showModal, inquiryId, institutionId}),
);

export const {action: showWebsiteFormModal} = createAction(
    `${domain}/SHOW_WEBSITE_FORM_MODAL`,
    (showModal, institutionId) => ({showModal, institutionId}),
);

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const {action: closeInquiryModals} = createAction(`${domain}/CLOSE_INQUIRY_MODALS`, () => {});

export const {action: fetchInquirySignupLink, success: fetchInquirySignupLinkSuccess} = createAction(
    `${domain}/FETCH_INQUIRY_SIGNUP_LINK`,
    institutionId => ({
        institutionId,
    }),
);

export const {action: showNewActionForm} = createAction(`${domain}/SHOW_NEW_ACTION_FORM`, show => ({show}));

export const {
    action: createInquiry,
    success: createInquirySuccess,
    failed: createInquiryFailed,
} = createAction(`${domain}/CREATE_INQUIRY`, (institutionId, inquiry, inquiryAction) => ({
    institutionId,
    inquiry,
    inquiryAction,
}));

export const {
    action: updateInquiry,
    success: updateInquirySuccess,
    failed: updateInquiryFailed,
} = createAction(`${domain}/UPDATE_INQUIRY`, (existingInquiry, updatedInquiry) => ({existingInquiry, updatedInquiry}));

export const {
    action: deleteInquiry,
    success: deleteInquirySuccess,
    failed: deleteInquiryFailed,
    aborted: deleteInquiryAborted,
} = createAction(`${domain}/DELETE_INQUIRY`, inquiryId => ({inquiryId}));

export const {
    action: createInquiryAction,
    success: createInquiryActionSuccess,
    failed: createInquiryActionFailed,
} = createAction(`${domain}/CREATE_INQUIRY_ACTION`, (inquiryId, inquiryAction) => ({inquiryId, inquiryAction}));

export const {action: editInquiryAction} = createAction(`${domain}/EDIT_INQUIRY_ACTION`, inquiryActionId => ({
    inquiryActionId,
}));

export const {success: updateInquiryActionSuccess, failed: updateInquiryActionFailed} = createAction(
    `${domain}/UPDATE_INQUIRY_ACTION`,
    inquiryAction => ({inquiryAction}),
);

export const {
    success: deleteInquiryActionSuccess,
    failed: deleteInquiryActionFailed,
    aborted: deleteInquiryActionAborted,
} = createAction(`${domain}/DELETE_INQUIRY_ACTION`, inquiryAction => ({inquiryAction}));
